import { render } from "./Cards.vue?vue&type=template&id=c4596dba&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=c4596dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4596dba"]])

export default __exports__